export const QuoteInfoType = {
    Start: "Start",
    Car: "Car",
    Driver: "Driver",
    Quote: "Quote",
}